module.exports = __webpack_public_path__ + "img/04.c15fe0c4.jpg";